import { cn } from '@/utils/utils';

export function PlainTextIcon({
  className,
  size,
}: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.38864 3.5782C6.3205 3.43325 6.21251 3.31068 6.07729 3.22483C5.94208 3.13898 5.78522 3.09339 5.62505 3.09339C5.46488 3.09339 5.30802 3.13898 5.1728 3.22483C5.03758 3.31068 4.92959 3.43325 4.86145 3.5782L0.361452 13.1407C0.271369 13.3424 0.263955 13.5713 0.340803 13.7784C0.41765 13.9855 0.572631 14.1541 0.772468 14.2482C0.972305 14.3423 1.20106 14.3543 1.40962 14.2815C1.61818 14.2088 1.78991 14.0572 1.88794 13.8593L2.98411 11.5312H8.26598L9.36145 13.8593C9.45674 14.0618 9.62858 14.2182 9.83916 14.294C10.0497 14.3698 10.2818 14.3589 10.4843 14.2636C10.6869 14.1683 10.8432 13.9965 10.919 13.7859C10.9949 13.5753 10.9839 13.3432 10.8886 13.1407L6.38864 3.5782ZM3.77864 9.84375L5.62505 5.9189L7.47215 9.84375H3.77864ZM14.0625 5.90625C13.0887 5.90625 12.3209 6.17765 11.7809 6.71344C11.696 6.78993 11.6275 6.88289 11.5796 6.98666C11.5317 7.09043 11.5054 7.20285 11.5022 7.31709C11.4991 7.43134 11.5192 7.54504 11.5613 7.65129C11.6034 7.75754 11.6667 7.85412 11.7473 7.93517C11.8279 8.01623 11.9241 8.08007 12.0301 8.12282C12.1361 8.16557 12.2496 8.18634 12.3639 8.18387C12.4782 8.18139 12.5907 8.15573 12.6948 8.10844C12.7988 8.06115 12.8922 7.99321 12.9692 7.90875C13.1801 7.69781 13.55 7.59093 14.0625 7.59093C14.836 7.59093 15.4688 8.09578 15.4688 8.71593V9.02461C15.028 8.8212 14.548 8.7168 14.0625 8.71875C12.3568 8.71875 10.9688 9.98015 10.9688 11.5312C10.9688 13.0823 12.3568 14.3437 14.0625 14.3437C14.6012 14.3451 15.1322 14.2153 15.6094 13.9655C15.7096 14.1164 15.8557 14.2312 16.0261 14.2927C16.1965 14.3542 16.3822 14.3592 16.5557 14.307C16.7292 14.2548 16.8812 14.1482 16.9894 14.0028C17.0976 13.8575 17.1561 13.6812 17.1563 13.5V8.71875C17.1563 7.16765 15.7683 5.90625 14.0625 5.90625ZM14.0625 12.6562C13.2891 12.6562 12.6563 12.1514 12.6563 11.5312C12.6563 10.9111 13.2891 10.4062 14.0625 10.4062C14.836 10.4062 15.4688 10.9111 15.4688 11.5312C15.4688 12.1514 14.836 12.6562 14.0625 12.6562Z"
        fill="currentColor"
      />
    </svg>
  );
}

export const TaskListIcon = ({
  className,
  size,
}: { className?: string; size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_897_4)">
        <path
          d="M9 9H15.1875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 4.5H15.1875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9 13.5H15.1875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.8125 4.5L3.9375 5.625L6.1875 3.375"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.8125 9L3.9375 10.125L6.1875 7.875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.8125 13.5L3.9375 14.625L6.1875 12.375"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_897_4">
          <rect width="18" height="18" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export const StrikethroughIcon = ({
  className,
  size,
  strokeWidth = 1.5,
}: { className?: string; size?: number; strokeWidth?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_885_93)">
        <path
          d="M2.8125 9H15.1875"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.0625 11.8125C5.0625 13.3657 6.82523 14.625 9 14.625C11.1748 14.625 12.9375 13.3657 12.9375 11.8125C12.9375 10.1412 11.4173 9.49219 9.73125 9"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.28119 6.1875C5.28119 4.6343 6.82806 3.375 9.00002 3.375C10.6172 3.375 11.8294 4.06898 12.375 5.0625"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_885_93">
          <rect width="18" height="18" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  );
};

export function MailIconFill({ size, color }: { size: number; color: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.875 2.5C0.839844 2.5 0 3.33984 0 4.375C0 4.96484 0.277344 5.51953 0.75 5.875L9.25 12.25C9.69531 12.582 10.3047 12.582 10.75 12.25L19.25 5.875C19.7227 5.51953 20 4.96484 20 4.375C20 3.33984 19.1602 2.5 18.125 2.5H1.875ZM0 6.875V15C0 16.3789 1.12109 17.5 2.5 17.5H17.5C18.8789 17.5 20 16.3789 20 15V6.875L11.5 13.25C10.6094 13.918 9.39063 13.918 8.5 13.25L0 6.875Z"
        fill={color}
      />
    </svg>
  );
}

export function SendIcon({
  className,
  size = 18,
}: { className?: string; size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 16.875V3.125"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.375 8.75L10 3.125L15.625 8.75"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function StopIcon({ className }: { className?: string }) {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="4" fill="currentColor" />
    </svg>
  );
}

export function GoogleIcon() {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.1001 9.98281H23.1335V9.93301H12.3335V14.733H19.1153C18.1259 17.5272 15.4673 19.533 12.3335 19.533C8.3573 19.533 5.1335 16.3092 5.1335 12.333C5.1335 8.35681 8.3573 5.13301 12.3335 5.13301C14.1689 5.13301 15.8387 5.82541 17.1101 6.95641L20.5043 3.56221C18.3611 1.56481 15.4943 0.333008 12.3335 0.333008C5.7065 0.333008 0.333496 5.70601 0.333496 12.333C0.333496 18.96 5.7065 24.333 12.3335 24.333C18.9605 24.333 24.3335 18.96 24.3335 12.333C24.3335 11.5284 24.2507 10.743 24.1001 9.98281Z"
        fill="#fbbc05"
      />
      <path
        d="M1.71729 6.74761L5.65988 9.63901C6.72668 6.99781 9.31028 5.13301 12.3337 5.13301C14.1691 5.13301 15.8389 5.82541 17.1103 6.95641L20.5045 3.56221C18.3613 1.56481 15.4945 0.333008 12.3337 0.333008C7.72448 0.333008 3.72728 2.93521 1.71729 6.74761Z"
        fill="#ea4335"
      />
      <path
        d="M12.3329 24.3332C15.4325 24.3332 18.2489 23.147 20.3783 21.218L16.6643 18.0752C15.4595 18.9878 13.9619 19.5332 12.3329 19.5332C9.2117 19.5332 6.5615 17.543 5.5631 14.7656L1.6499 17.7806C3.6359 21.6668 7.6691 24.3332 12.3329 24.3332Z"
        fill="#34a853"
      />
      <path
        d="M24.1001 9.98339H23.1335V9.93359H12.3335V14.7336H19.1153C18.6401 16.0758 17.7767 17.2332 16.6631 18.0762C16.6637 18.0756 16.6643 18.0756 16.6649 18.075L20.3789 21.2178C20.1161 21.4566 24.3335 18.3336 24.3335 12.3336C24.3335 11.529 24.2507 10.7436 24.1001 9.98339Z"
        fill="#4285f4"
      />
    </svg>
  );
}

export function ChatIcon(props: React.ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      className={cn('size-4', props.className)}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g clipPath="url(#clip0_1722_1981)">
        <path d="M6.125 10.8125H2.25781C2.16457 10.8125 2.07515 10.7755 2.00922 10.7095C1.94329 10.6436 1.90625 10.5542 1.90625 10.4609V6.59375C1.90625 5.47487 2.35072 4.40181 3.14189 3.61064C3.93306 2.81947 5.00612 2.375 6.125 2.375C7.24388 2.375 8.31694 2.81947 9.10811 3.61064C9.89928 4.40181 10.3437 5.47487 10.3438 6.59375C10.3437 7.71263 9.89928 8.78569 9.10811 9.57686C8.31694 10.368 7.24388 10.8125 6.125 10.8125Z" />
        <path d="M5.89648 10.8124C6.18735 11.6351 6.72616 12.3473 7.43869 12.851C8.15122 13.3548 9.00241 13.6251 9.875 13.6249H13.7422C13.8354 13.6249 13.9248 13.5879 13.9908 13.5219C14.0567 13.456 14.0938 13.3666 14.0938 13.2733V9.40615C14.0937 8.32726 13.6803 7.28937 12.9386 6.50589C12.1969 5.72241 11.1831 5.25289 10.1059 5.19385" />
      </g>
      <defs>
        <clipPath id="clip0_1722_1981">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const SparklesIcon = (props: React.ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={15}
      height={15}
      fill="none"
      {...props}
    >
      <mask
        id="a"
        width={15}
        height={15}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'luminance',
        }}
      >
        <path fill="#fff" d="M15 0H0v14.931h15V0Z" />
      </mask>
      <g fill="currentColor" mask="url(#a)">
        <path d="M5.622 1.875c.208 0 .32.13.4.305.457.982.922 1.96 1.37 2.947a.914.914 0 0 0 .488.492c.948.425 1.888.865 2.827 1.308.13.061.268.144.357.253.19.231.057.564-.267.716-.99.46-1.98.926-2.974 1.377a.772.772 0 0 0-.407.42c-.444.97-.899 1.938-1.35 2.905-.097.207-.226.392-.476.394-.258.002-.4-.178-.5-.397-.463-.996-.922-1.994-1.397-2.985a.669.669 0 0 0-.294-.297 254.531 254.531 0 0 0-3.036-1.41c-.195-.09-.368-.205-.363-.438.006-.25.16-.41.385-.514 1.015-.466 2.03-.93 3.037-1.41a.644.644 0 0 0 .273-.29c.478-1 .943-2.003 1.41-3.006.103-.223.256-.37.517-.37ZM9.3 2.772c.175-.14.275-.264.405-.319.46-.192.934-.354 1.397-.542a.434.434 0 0 0 .216-.211c.187-.455.358-.915.53-1.375.064-.171.153-.321.353-.325.205-.005.292.154.354.322.169.445.326.893.511 1.331a.563.563 0 0 0 .275.275c.461.192.938.344 1.397.541.112.049.253.21.247.312-.008.121-.136.288-.253.339-.458.197-.937.35-1.399.537a.525.525 0 0 0-.259.258c-.181.439-.342.887-.503 1.334-.066.182-.164.332-.372.335-.201.003-.295-.143-.36-.317-.165-.453-.325-.91-.51-1.356a.528.528 0 0 0-.261-.258c-.462-.191-.938-.348-1.398-.542-.124-.052-.211-.19-.37-.34ZM9.412 12.057c.066-.053.166-.176.295-.229.44-.182.887-.344 1.335-.505.15-.053.247-.13.304-.288.161-.455.342-.903.51-1.355.058-.156.137-.281.32-.295.2-.015.299.107.362.271.177.465.344.935.534 1.395.04.098.145.201.244.24.448.181.905.342 1.36.505.173.063.318.151.325.354.007.218-.148.312-.325.377-.44.16-.885.308-1.317.486a.595.595 0 0 0-.293.29c-.171.409-.31.83-.464 1.247-.021.059-.035.13-.078.168-.1.087-.217.219-.32.213a.46.46 0 0 1-.329-.23c-.198-.464-.352-.948-.543-1.416a.527.527 0 0 0-.262-.263c-.44-.18-.891-.334-1.337-.5-.177-.065-.333-.15-.32-.464h-.001Z" />
      </g>
    </svg>
  );
};
